<template>
  <div class="quiz-or-poll">
    <TheContent
      v-for="item of content"
      :key="item.id"
      :elem="item"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';
  import { useIndexStore } from '~/store';

  type Attributes = {
    id: number;
    content: TContent[];
  };

  export default defineNuxtComponent({
    name: 'QuizOrPoll',

    components: { TheContent },

    props: {
      elem: {
        type: Object as PropType<TContent<Attributes>>,
        required: true,
      },
    },

    setup() {
      return {
        indexStore: useIndexStore(),
      };
    },

    computed: {
      userId() {
        return this.indexStore.userIntegerId;
      },

      content(): TContent[] {
        return this.elem.attributes.content.map((item: any) => {
          if (item.type === 'iframe') {
            return {
              ...item,
              attributes: {
                ...item.attributes,
                // для локальных тестов
                // src: `http://localhost:8080/tests/689?url=${encodeURIComponent(this.$route.path)}`,
                src: `${item.attributes.src}?url=${encodeURIComponent(this.$route.path)}`,
              },
            };
          }

          return item;
        });
      },

      iframeId(): string {
        return this.content.find((item: any) => item.type === 'iframe')?.attributes?.id;
      },
    },

    watch: {
      userId(userId) {
        if (!this.iframeId) {
          console.error('No iframe id found in attributes');
          return;
        }
        const iframe = document.getElementById(this.iframeId);
        if (!iframe) {
          console.error(`No iframe with id "${this.iframeId}" found in DOM`);
          return;
        }

        iframe.addEventListener(
          'load',
          () => {
            this.$logger('post message to iframe', { iframe, userId });
            // @ts-ignore
            iframe.contentWindow.postMessage({ type: 'userId', userId }, '*');
          },
          { passive: true },
        );
      },
    },
  });
</script>

<style lang="scss" scoped></style>
